import { Modal } from 'antd'
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBarcode,
    faCalendarDays,
    faCreditCard,
    faFilter,
    faGasPump,
    faMapLocation,
    faRotateBack,
    faUser,
} from '@fortawesome/free-solid-svg-icons'
import { Container } from './styled'
import { listarFormasPagamento, listarFrotas, listarResponsaveis } from './meta'
import { tabs_local } from '../../meta'
import { FornecedorItens } from '../../../../../services/Fornecedores'
import { PropriedadeItens } from '../../../../../services/Propriedades'
import Tabs from '../../../../../Components/Tabs'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import DateRangePickerCustom from '../../../../../Components/CustomUi/dateRangePicker'
import { Box } from '../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../Components/CustomUi/inline'
import { Render } from '../../../../../Components/CustomUi/render'
import { Select } from '../../../../../Components/CustomUi/Select'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import { TitleH1 } from '../../../../../Components/CustomUi/titleH1'

interface ModalFiltroAbastecimentoProps {
    abrirModal: boolean
    fecharModal: Function
    /**Lista já carregada, usada para montar as opções de responsável, frota e forma de pagamento */
    listar_abastecimento: any[]
    /**Mesmas listas usadas na gaveta de cadastro, vindas da tela principal */
    data_postos: FornecedorItens[]
    data_propriedades: PropriedadeItens[]
    /**Define se o filtro busca abastecimentos feitos em `Posto` ou em `Propriedade` */
    tab_local: string
    setTab_local: React.Dispatch<React.SetStateAction<string>>
    intervalo_datas: any[]
    setIntervalo_datas: React.Dispatch<React.SetStateAction<any[]>>
    fornecedor_selecionado: string
    setFornecedor_selecionado: React.Dispatch<React.SetStateAction<string>>
    setFornecedor_selecionado_id: React.Dispatch<React.SetStateAction<number>>
    propriedade_selecionada: string
    setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
    setPropriedade_selecionada_id: React.Dispatch<React.SetStateAction<number>>
    responsavel_selecionado: string
    setResponsavel_selecionado: React.Dispatch<React.SetStateAction<string>>
    setResponsavel_selecionado_id: React.Dispatch<React.SetStateAction<number>>
    frota_selecionada: string
    setFrota_selecionada: React.Dispatch<React.SetStateAction<string>>
    forma_pagamento: string
    setForma_pagamento: React.Dispatch<React.SetStateAction<string>>
    setForma_pagamento_id: React.Dispatch<React.SetStateAction<number>>
    reembolsados: boolean
    setReembolsados: React.Dispatch<React.SetStateAction<boolean>>
    descontados_folha: boolean
    setDescontados_folha: React.Dispatch<React.SetStateAction<boolean>>
    filtrarAbastecimento: Function
    limparFiltros: Function
}

export const ModalFiltroAbastecimento: React.FC<ModalFiltroAbastecimentoProps> = ({
    abrirModal,
    fecharModal,
    listar_abastecimento,
    data_postos,
    data_propriedades,
    tab_local,
    setTab_local,
    intervalo_datas,
    setIntervalo_datas,
    fornecedor_selecionado,
    setFornecedor_selecionado,
    setFornecedor_selecionado_id,
    propriedade_selecionada,
    setPropriedade_selecionada,
    setPropriedade_selecionada_id,
    responsavel_selecionado,
    setResponsavel_selecionado,
    setResponsavel_selecionado_id,
    frota_selecionada,
    setFrota_selecionada,
    forma_pagamento,
    setForma_pagamento,
    setForma_pagamento_id,
    reembolsados,
    setReembolsados,
    descontados_folha,
    setDescontados_folha,
    filtrarAbastecimento,
    limparFiltros
}) => {

    const [open_fornecedor, setOpen_fornecedor] = useState<boolean>(false)
    const [open_propriedade, setOpen_propriedade] = useState<boolean>(false)
    const [open_responsavel, setOpen_responsavel] = useState<boolean>(false)
    const [open_frota, setOpen_frota] = useState<boolean>(false)
    const [open_forma_pagamento, setOpen_forma_pagamento] = useState<boolean>(false)

    const em_posto = tab_local === 'Posto'

    return (
        <Modal
            open={abrirModal}
            onCancel={() => fecharModal()}
            width={700}
            footer={false}
            title={<TitleH1>Filtro avançado</TitleH1>}
        >
            <Container>
                <Tabs
                    tabs={tabs_local}
                    selecionado={tab_local}
                    onChange={setTab_local}
                    indexInicial={em_posto ? 0 : 1}
                    trackWidth={321}
                />

                <Inline>
                    <DateRangePickerCustom
                        label='Intervalo de datas'
                        icon={faCalendarDays}
                        value={intervalo_datas}
                        onChange={setIntervalo_datas}
                        width='100%'
                    />

                    <Render condition={em_posto}>
                        <Select
                            label='Fornecedor'
                            icon={faGasPump}
                            placeholder='Selecione o fornecedor'
                            value={fornecedor_selecionado}
                            onChange={setFornecedor_selecionado}
                            onChangeID={setFornecedor_selecionado_id}
                            open={open_fornecedor}
                            trigger={setOpen_fornecedor}
                            items={data_postos}
                            descricaoItem={'nome'}
                            idItem={'cod'}
                            allowClear
                        />
                    </Render>

                    <Render condition={!em_posto}>
                        <Select
                            label='Propriedade'
                            icon={faMapLocation}
                            placeholder='Selecione a propriedade'
                            value={propriedade_selecionada}
                            onChange={setPropriedade_selecionada}
                            onChangeID={setPropriedade_selecionada_id}
                            open={open_propriedade}
                            trigger={setOpen_propriedade}
                            items={data_propriedades}
                            descricaoItem={'nome'}
                            idItem={'cod'}
                            allowClear
                        />
                    </Render>
                </Inline>

                <Inline>
                    <Select
                        label='Responsável pelo abastecimento'
                        icon={faUser}
                        placeholder='Selecione o responsável'
                        value={responsavel_selecionado}
                        onChange={setResponsavel_selecionado}
                        onChangeID={setResponsavel_selecionado_id}
                        open={open_responsavel}
                        trigger={setOpen_responsavel}
                        items={listarResponsaveis(listar_abastecimento)}
                        descricaoItem={'nome'}
                        idItem={'cod'}
                        allowClear
                    />

                    <Select
                        label='Frota'
                        icon={faBarcode}
                        placeholder='Selecione a frota'
                        value={frota_selecionada}
                        onChange={setFrota_selecionada}
                        open={open_frota}
                        trigger={setOpen_frota}
                        items={listarFrotas(listar_abastecimento)}
                        descricaoItem={'nome'}
                        idItem={'cod'}
                        allowClear
                    />
                </Inline>

                <Select
                    label='Forma de pagamento'
                    icon={faCreditCard}
                    placeholder='Selecione a forma de pagamento'
                    value={forma_pagamento}
                    onChange={setForma_pagamento}
                    onChangeID={setForma_pagamento_id}
                    open={open_forma_pagamento}
                    trigger={setOpen_forma_pagamento}
                    items={listarFormasPagamento(listar_abastecimento)}
                    descricaoItem={'nome'}
                    idItem={'cod'}
                    allowClear
                />

                <Box>
                    <Switcher
                        label='Reembolsos'
                        isChecked={reembolsados}
                        trigger={setReembolsados}
                    />
                    <Switcher
                        label='Desconto autorizado em folha'
                        isChecked={descontados_folha}
                        trigger={setDescontados_folha}
                    />
                </Box>

                <Inline justifyContent='flex-end'>
                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={faRotateBack} />}
                        onClick={() => limparFiltros()}
                        type='secondary'
                        danger
                    >
                        Limpar
                    </ButtonCustom>
                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={faFilter} />}
                        onClick={() => filtrarAbastecimento()}
                    >
                        Filtrar
                    </ButtonCustom>
                </Inline>
            </Container>
        </Modal>
    )
}
